
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.696 4.011c.264 0 .522-.078.742-.224l1.932-1.289v6.193c0 .369-.3.668-.669.668h-.668v1.337h.668a2.006 2.006 0 002.006-2.005V2.498a1.337 1.337 0 00-2.079-1.112l-1.932 1.288h-4.68A2.006 2.006 0 004.011 4.68v.668h1.337V4.68c0-.37.299-.669.668-.669h4.68z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.844 12.326c.237-.19.532-.293.835-.293h5.348c.37 0 .669-.299.669-.668V7.354c0-.37-.3-.669-.669-.669H3.342c-.369 0-.668.3-.668.669v5.909l1.17-.937zm.835 1.044h5.348a2.006 2.006 0 002.006-2.005V7.354a2.006 2.006 0 00-2.006-2.006H3.342a2.006 2.006 0 00-2.005 2.006v5.909c0 1.12 1.297 1.744 2.172 1.044l1.17-.937z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.01 9.36c0-.37.3-.67.67-.67h4.01a.669.669 0 010 1.338H4.68c-.37 0-.67-.3-.67-.669z","fill":"currentColor"}})])
          )
        }
      }
    